import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';

const styles = {
  mainInfoPanel: {
    backgroundColor: colors.neutral.white,
    borderRadius: '1rem',
    padding: '2.4rem 4rem',
    marginBottom: '4rem',
  },
  actionButton: { textTransform: 'uppercase', marginBottom: '1.6rem', '&:last-of-type': { marginBottom: 0 } },
};

const createStyles = createUseStyles(styles);

export { createStyles };
